import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';

// Import page components
import HomePage from './HomePage';
import ProductsPage from './ProductsPage';
import ServicesPage from './ServicesPage';
import ReferencesPage from './ReferencesPage';
import NewsPage from './NewsPage';
import GalleryPage from './GalleryPage';
import DocumentsPage from './DocumentsPage';
import AboutPage from './AboutPage';
import ContactPage from './ContactPage';
import AdminPanel from './AdminPanel';

// Database test utilities removed for security
// Use only through direct file imports when needed

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Admin Panel - separate from main layout */}
        <Route path="/admin" element={<AdminPanel />} />
        
        {/* Main website routes with Layout */}
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/references" element={<ReferencesPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/documents" element={<DocumentsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Router>
  );
};

export default App;